var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Header/Search/SearchInput/index.js",
  _this = this;
import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import SearchIcon from '../icons/searchIcon.svg';
import { withTheme } from '../../../../core/ThemeProvider';
var SCSearchBox = withTheme(styled.div.withConfig({
  displayName: "SearchInput__SCSearchBox",
  componentId: "sc-1hm1rfh-0"
})(function (props) {
  return css(["position:relative;font-family:", ";display:flex;"], props.coreTheme.header.search.searchInputFont);
}));
var SCSearchInput = withTheme(styled.input.withConfig({
  displayName: "SearchInput__SCSearchInput",
  componentId: "sc-1hm1rfh-1"
})(function (props) {
  return css(["color:", ";font-family:", ";font-size:1rem;border-radius:7px;padding:10px;&::placeholder{color:", ";}@media (max-width:", "){width:100%;}"], props.coreTheme.header.search.searchInputFontColor, props.coreTheme.header.search.searchInputFont, props.coreTheme.header.search.searchInputPlaceholderFontColor, props.coreTheme.brk_md);
}));
var SCSearchIcon = withTheme(styled.div.withConfig({
  displayName: "SearchInput__SCSearchIcon",
  componentId: "sc-1hm1rfh-2"
})(["width:1rem;height:100%;position:absolute;padding:0 10px;cursor:pointer;top:0;right:0;svg{width:1rem;height:100%;}"]));
var SearchInput = function SearchInput(_ref) {
  var onSearchIconClick = _ref.onSearchIconClick,
    onSearchInputActivated = _ref.onSearchInputActivated,
    searchInputClassName = _ref.searchInputClassName,
    placeholder = _ref.placeholder;
  useEffect(function () {
    // Notify the consumer of this component when the search input is mounted on the DOM.
    onSearchInputActivated && onSearchInputActivated();
  }, []);
  return /*#__PURE__*/React.createElement(SCSearchBox, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(SCSearchInput, {
    className: searchInputClassName,
    type: "text",
    placeholder: placeholder,
    "data-testid": "search-input",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(SCSearchIcon, {
    "data-testid": "search-input-icon",
    onClick: onSearchIconClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(SearchIcon, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 9
    }
  })));
};
export default SearchInput;